module.exports = __webpack_public_path__ + "img/align-left.4715f03c.svg";